module.exports = __webpack_public_path__ + "img/vipEquityE.6399cebe.png";